var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',{staticClass:"icon",style:(_vm.userColorStyle),attrs:{"title":_vm.username}},[_c('i',{staticClass:"far fa-user"})])}
var staticRenderFns = []

export { render, staticRenderFns }